import styled from 'styled-components';

export const CadastrosContainer = styled.div`
  width: 100%;
`;

export const CadastrosContent = styled.div`
  border-radius: 8px;
  padding: 24px;
`;

export const CadastrosInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    margin: 0;

    &:first-child {
      font-size: 18px;
      font-weight: 500;
    }
  }
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FormRow = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const ErrorMessage = styled.div`
  background-color: #f8d7da;
  color: #721c24;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 14px;
`;

export const SuccessMessage = styled.div`
  background-color: #d4edda;
  color: #155724;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 14px;
`;
